// extracted by mini-css-extract-plugin
module.exports = {"description":"_66b3b3fa"};